// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@flip/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@flip/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { postRequestQuote } from "@flip/App/Services/RequestQuoteService";
import { ErrorApiDefaultMessage } from "@flip/XDL/constants";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";

type HandlerType = ApiHandler<{ parameters: FormData } & HasOnSuccess<any> & HasOnError<string>, any>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await postRequestQuote(props.apiParameter.parameters);
    } catch (error) {
        const failedMessage = error?.errorMessage || translate(ErrorApiDefaultMessage);
        props.parameter.onError?.(failedMessage);
        return false;
    }
};

export const _GaRequestAQuote: HandlerType = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const data = props.apiResult;

    if (state.xGoogleAnalytics.rfqEvent && data) {
        const dataLayer = getDataLayer();
        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.rfqEventName,
            affiliation: data.company,
            user: data.email,
            page_path: getCurrentPage(state).type,
            item_name: data.partNumber,
            item_id: data.partNumber,
            erpQuoteNumber: data.erpQuoteNumber,
        };

        dataLayer.push(googleAnalyticsData);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, _GaRequestAQuote, ExecuteOnSuccessCallback];

const requestQuote = createHandlerChainRunner(chain, "postPromotionSubmit");
export default requestQuote;
